import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister"
import cx from "classnames";
import ModalLang from "../modal-lang/component";
import ModalLeave from "../modal-leave/component";
import {marketRegister} from "../../services/marketRegister";
import ModalVideo from "../modal-video/component";
import ModalMarket from "../modal-market/component";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import queryString from "query-string";

class HeaderMobileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            options: {
                home: false,
                advertise: false,
                about: false
            },
            menu: false,
            layout: false,
            dropwdown: false,
            temp_lang: null,
            language: false,
            leave: false,
            home: false,
            profile: false,
            market: null,
            marketModal: false,
            temp_market: null,
            languages: [],
            markets: [],
            temp_option: null
        };
        this._lang = this._lang.bind(this);
        this._market = this._market.bind(this);
        this._leave = this._leave.bind(this);
        this._setVideo = this._setVideo.bind(this);
    };

    componentWillMount() {
        this._updateLayout();
        this._updateUser();
        this._updateLang();
        this._updateLanguages();
        this._updateMarket();
        this._updateMarkets();
    }

    _updateLang(){
        this.setState({
            lang: langRegister.lang()
        });
    }

    _updateLayout() {
        try {
            this.setState({layout: this.props.layout});
        } catch (e) {}
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user
            });
        }
    }

    _updateLanguages(){
        this.setState({languages: JSON.parse(salesChannelRegister.get("languages"))?JSON.parse(salesChannelRegister.get("languages")):[]}, () => console.log(this.state.languages));
    }

    _updateMarket(){
        this.setState({market: marketRegister.code()});
    }

    _updateMarkets(){
        this.setState({markets: marketRegister.allMarkets()});
    }

    _signout() {
        if(this.state.user){
            if(this.state.user.admin){
                this.setState({home: true, leave: true});
            }else{
                userRegister.remove();
                tokenRegister.remove();
                window.location.reload();
            }
        }else{
            userRegister.remove();
            tokenRegister.remove();
            window.location.reload();
        }
    }

    _openMenu() {
        this.setState({menu: true});
    }

    _closeMenu() {
        this.setState({menu: false});
    }

    _open(option) {
        this.state.options[option] = !this.state.options[option];
        this.setState({options: this.state.options});
    }

    _scrollTo(element) {
        if(this.props.props.location.pathname === "/" + marketRegister.code() + "/" + langRegister.lang()){
            let offSet = 0, timeout = null;
            element = document.getElementById(element);
            console.log(element);
            if (element) {
                const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
                window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
                this.setState({menu: false});
            }
        }else{
            try {
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/scroll/" + element);
            } catch (e) {}
        }
    }

    _home() {
        if (this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1) {
            this.setState({leave: true, home: true});
        }else{
            try {
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
                this._closeMenu();
            } catch (e) {}
        }
    }

    _signup() {
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }

        this._closeMenu();
    }

    /*
    _register() {
        try {
            this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/register");
            this._closeMenu();
        } catch (e) {}
    }
    */

    _register() {

        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/register", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/register", '_blank');
        }

        this._closeMenu();

        /*
        if(this.props.props.location.pathname.indexOf("signup") !== -1){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register" + "?from_path=" + this.props.props.location.pathname);
        }else{
            let query = queryString.parse(this.props.props.location.search);
            if(query){
                if(query.from_path){
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register?from_path=" + query.from_path);
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register");
                }
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register");
            }
        }
        this._closeMenu();
        */
    }

    _login() {

        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }

        this._closeMenu();

        /*
        if(this.props.props.location.pathname.indexOf("signup") !== -1){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login" + "?from_path=" + this.props.props.location.pathname);
        }else{
            let query = queryString.parse(this.props.props.location.search);
            if(query){
                if(query.from_path){
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login?from_path=" + query.from_path);
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
                }
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
            }
        }
        this._closeMenu();
        */
    }

    _terms(link){
        window.open('https://legal.'+dataRegister.domain+"/"+marketRegister.code() + "/" + langRegister.lang() +"/"+ link + "/adbop", '_blank');
    }

    _help(){
        window.open('https://help.'+dataRegister.domain+"/"+marketRegister.code() + "/" + langRegister.lang() +"/adbop", '_blank');
    }

    _profile() {
        if (this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1) {
            this.setState({leave: true, profile: true});
        }else{
            try {
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
                this._closeMenu();
            } catch (e) {}
        }
    }

    _go(option){
        if (this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1) {
            this.setState({leave: true, home: true, temp_option: option});
        }else{
            try {
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + option);
                this._closeMenu();
            } catch (e) {}
        }
    }

    /*
    _login() {
        try {
            if (this.props.props.location.pathname.indexOf("signup") !== -1) {
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() +"/login?from=" + this.props.props.location.pathname);
            } else {
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() +"/login");
            }
        } catch (error) {}
    }
    */

    _lang(lang){
        if(lang){
            langRegister.set(lang);
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            if(this.props.props.location.pathname.indexOf("image") !== -1){
                this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang());
                window.location.reload();
            }else{
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
            }
        }else{
            this.setState({language: false});
        }
    }

    _setLang(prop){
        if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
            this.setState({language: true, temp_lang: prop, dropdown: false}, () => {});
        }else{
            let string = "/" + marketRegister.code() + "/" + langRegister.lang();
            let re = new RegExp(string,"g");
            let url = this.props.props.location.pathname.replace(re,'');
            langRegister.set(prop);
            this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang() + url);
            window.location.reload();
        }
    }

    _market(market){
        if(market){
            marketRegister.set(market);
            let default_lang = marketRegister.defaultLang();
            try{
                sessionStorage.clear();
            }catch (e) {}
            this.props.props.history.replace("/" + market + "/" + default_lang);
            window.location.reload();
        }else{
            this.setState({marketModal: false});
        }
    }

    _setMarket(market){
        if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
            this.setState({marketModal: true, temp_market: market}, () => {});
        }else{
            marketRegister.set(market);
            let default_lang = marketRegister.defaultLang();
            try{
                sessionStorage.clear();
            }catch (e) {}
            this.props.props.history.replace("/" + market + "/" + default_lang);
            window.location.reload();
        }
    }

    _setVideo(value){
        this.setState({video: value});
    }

    _leave(value){
        if(value){
            if(this.state.home){
                try {
                    if(this.state.user.admin){
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                    }
                }catch (error){}
                try {
                    if(this.state.temp_option){
                        this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + this.state.temp_option );
                    }else{
                        this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
                    }
                } catch (e) {}
            }else if(this.state.profile){
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
            }else{
                if(this.props.props.location.pathname.indexOf("industry") !== -1){
                    window.location.reload();
                }else{
                    this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/industry");
                }
            }
        }else{
            this.setState({leave: false});
        }
    }

    _renderLanguage(lang){
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    _renderMarket(market){
        let value = "";
        for(let i = 0; i < this.state.markets.length; i++){
            if(this.state.markets[i].code === market){
                value = this.state.markets[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    _renderText(item) {
        return langRegister.get("mobile-menu", item);
    }

    render() {
        return (
            <div>
                <div className={
                    cx(Styles.menu,
                        {
                            [Styles.menuOpen]: this.state.menu,
                        })
                }>
                    {
                        this.state.language &&
                        <ModalLang setLang={this._lang} lang={this.state.temp_lang} props={this.props}/>
                    }
                    {
                        this.state.leave &&
                        <ModalLeave setLeave={this._leave} props={this.props}/>
                    }
                    {
                        this.state.video &&
                        <ModalVideo setVideo={this._setVideo} props={this.props}/>
                    }
                    {
                        this.state.marketModal &&
                        <ModalMarket setMarket={this._market} market={this.state.temp_market} props={this.props}/>
                    }
                    <div className={Styles.menuInner}>
                        <img onClick={() => this._home()} className={Styles.menuInnerLogo}
                             src={require("../../assets/images/logo_mobile.svg")}/>
                        {
                            !this.state.layout &&
                            <img className={Styles.menuInnerFigure}
                                 src={require("../../assets/images/figure_mobile_one.png")}/>
                        }
                        {
                            this.state.user.email && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon.svg")}/>
                        }
                        {
                            this.state.user.email && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon_reseller.svg")}/>
                        }
                        <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose}
                             src={require("../../assets/images/cross_icon.png")}/>
                        <div className={Styles.menuInnerOptions}>
                            <div className={Styles.menuInnerOptionsItem}>
                                <div onClick={() => this._open('home')} className={Styles.menuInnerOptionsItem}>
                                    {
                                        this.state.options.home &&
                                        <div className={Styles.menuInnerOptionsItemIcon}>–</div>
                                        ||
                                        <div className={Styles.menuInnerOptionsItemIcon}>+</div>
                                    }
                                    <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_1")}</div>
                                </div>
                                <div className={
                                    cx(Styles.menuInnerOptionsItemDropdown,
                                        {
                                            [Styles.menuInnerOptionsItemDropdownOpen]: this.state.options.home,
                                        })
                                }>
                                    <div onClick={() => this._scrollTo('howto')}
                                         className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_2")}
                                    </div>
                                    <div onClick={() => this._setVideo(true)} className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_3")}
                                    </div>
                                    <div onClick={() => this._scrollTo('benefits')} className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_4")}
                                    </div>
                                    <div onClick={() => this._scrollTo('features')} className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_5")}
                                    </div>
                                    <div onClick={() => this._scrollTo('faq')} className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_6")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.menuInnerOptionsItem}>
                                <div onClick={() => this._signup()} className={Styles.menuInnerOptionsItem}>
                                    <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_7")}</div>
                                </div>
                            </div>
                            <div className={Styles.menuInnerOptionsItem}>
                                <div onClick={() => this._go("/about")} className={Styles.menuInnerOptionsItem}>
                                    <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_8")}</div>
                                </div>
                            </div>
                            <div className={Styles.menuInnerOptionsItem}>
                                <a style={{textDecoration: "none", color: "black"}} href="mailto:support@adbop.com?Subject=Hello" target="_top">
                                    <div className={Styles.menuInnerOptionsItem}>
                                        <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_9")}</div>
                                    </div>
                                </a>
                            </div>
                            <div className={
                                cx(Styles.menuInnerOptionsItem,
                                    {
                                        [Styles.menuInnerOptionsItemLast]: true
                                    })
                            }>
                                <div onClick={() => this._go("/vip")} className={Styles.menuInnerOptionsItem}>
                                    <div className={Styles.menuInnerOptionsItemText}>{this._renderText("item_10")}</div>
                                </div>
                            </div>

                            <div className={Styles.dropdown}>
                                <select className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this._setLang(event.target.value)}>
                                    {
                                        this.state.languages.map((item) => {
                                            return(
                                                <option value={item.code}>{item.names[langRegister.lang()]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={Styles.dropdownText}>
                                    {this._renderLanguage(this.state.lang)}
                                </div>
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_grey.svg")}/>
                            </div>

                            <div className={Styles.dropdown}>
                                <select value={this.state.market} onChange={(event) => this._setMarket(event.target.value)} className={Styles.dropdownSelection}>
                                    {
                                        this.state.markets.map((item) => {
                                            return(
                                                <option value={item.code}>{item.names[langRegister.lang()]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={Styles.dropdownText}>
                                    {this._renderMarket(this.state.market)}
                                </div>
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_grey.svg")}/>
                            </div>

                            <div className={Styles.divider}/>

                            <div onClick={() => this._signup()} className={Styles.button}>
                                {this._renderText("item_11")}
                            </div>
                            {
                                this.state.user.email &&
                                <div onClick={() => this._signout()} className={Styles.button}>
                                    {this._renderText("item_12")}
                                </div>
                            }
                            {
                                !this.state.user.email &&
                                <div onClick={() => this._login()} className={Styles.button}>
                                    {this._renderText("item_13")}
                                </div>
                            }
                            <div className={Styles.socialIcons}>
                                    <a className={Styles.socialIcon} href={"https://business.facebook.com/adBop-342034956357879/?business_id=418075078355273"} target={"_blank"}>
                                        <img className={Styles.socialIconFb}
                                             src={require("../../assets/images/facebook_icon.png")}/>
                                    </a>
                                    <a className={Styles.socialIcon} href={"https://instagram.com/adbop"} target={"_blank"}>
                                        <img className={Styles.socialIconInstagram}
                                             src={require("../../assets/images/instagram_icon.png")}/>
                                    </a>
                                {
                                    false &&
                                    <div className={Styles.socialIcon}>
                                        <img className={Styles.socialIconLinkedIn}
                                             src={require("../../assets/images/linkedin_icon.png")}/>
                                    </div>
                                }
                                {
                                    false &&
                                    <div className={Styles.socialIcon}>
                                        <img className={Styles.socialIconTwitter}
                                             src={require("../../assets/images/twitter_icon.png")}/>
                                    </div>
                                }
                            </div>
                            <div className={Styles.terms}>
                                <span onClick={() => this._terms("terms")}>{this._renderText("item_14")}</span> | <span onClick={() => this._terms("privacy")}>{this._renderText("item_15")}</span> | <span onClick={() => this._terms("acceptance")}>{this._renderText("item_16")}</span>
                            </div>
                            <div style={{width: "100%", height: "200px"}}/>
                        </div>
                    </div>
                </div>
                {
                    this.state.menu &&
                    <div className={Styles.overlay}/>
                }
            </div>
        );
    }
}

export default HeaderMobileMenu;


// WEBPACK FOOTER //
// ./src/components/header-mobile-menu/component.js